<script setup lang="ts">
import { onMounted, onUnmounted, onUpdated, ref } from "vue";
import { useBaseLayoutHeight } from "@/components/BaseLayout/composable/useBaseLayoutHeight";

defineProps<{
    hasSubHeaderContent: boolean;
    hasCartButtonContent: boolean;
}>();

const subHeaderElement = ref<HTMLElement | null>(null);
const { initializeWithElement, reset } = useBaseLayoutHeight();

onMounted(() => {
    if (subHeaderElement.value) initializeWithElement(subHeaderElement.value);
});

onUpdated(() => {
    if (subHeaderElement.value) initializeWithElement(subHeaderElement.value);
});

onUnmounted(() => reset());

// No Tailwind utility covers an arbitrary multi-stop linear-gradient like this brand band.
const subHeaderStyle = {
    backgroundImage: "linear-gradient(to right, #c80548 0%, #be0345 11%, #a70245 22%, #8b0248 33%, #64024e 44%, #3c0552 56%, #1b0856 67%, #060b58 78%, #00105b 89%, #00125c 100%)",
    backgroundSize: "cover",
};
</script>

<template>
    <div
        v-if="hasSubHeaderContent || hasCartButtonContent"
        ref="subHeaderElement"
        :style="subHeaderStyle"
    >
        <div class="container mx-auto max-lg:max-w-none! max-lg:px-[5px]! max-lg:py-0! flex flex-row gap-x-module-sm relative">
            <div v-if="hasSubHeaderContent" class="grow min-w-0 min-h-20 py-[5px] flex items-center">
                <div class="w-full">
                    <slot name="subHeader"/>
                </div>
            </div>

            <div v-if="hasCartButtonContent" class="shrink-0 min-h-20 flex items-stretch">
                <slot name="cartButton"/>
            </div>
        </div>
    </div>
</template>
